import { t } from 'ember-intl';

import CustomOptions from 'umg-ember-backend/components/page-builder/options/form/section/custom-options';
import DisplayOptions from 'umg-ember-backend/components/page-builder/options/form/section/display-options';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

<template>
  {{#if @mlp.isV2}}
    <DisplayOptions
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
    <CustomOptions
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
  {{else}}
    <InfoBox @type='warning' class='u-margin-small'>
      {{t 'page_builder.options.no_settings'}}
    </InfoBox>
  {{/if}}
</template>
